import React, {useEffect} from "react";
import {Button, Card, CardActions, CardContent, Grid, Stack, Typography} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {useAuth0} from "@auth0/auth0-react";
import {useTranslation} from "react-i18next";
import { useTenantConfig } from '../../security/tenant-config-context';

function Login() {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const {isAuthenticated, logout} = useAuth0();
    const hasRun = React.useRef(false);
    const isBeheer = window.location.pathname.startsWith('/beheer');
    const redirectUri = `${window.location.origin}${isBeheer ? '/beheer/login' : '/login'}`;

    const { cfg } = useTenantConfig();
    const websiteUrl = cfg.ui?.website ?? '/brand/default.svg';

    useEffect(() => {

        if (isAuthenticated) {
            logout({
                logoutParams: {
                    returnTo: redirectUri,
                }
            }).then(r => {
            });
        }
    }, [hasRun, isAuthenticated])

    return (
        <Grid container alignItems="center" justifyContent="center" spacing={1} sx={{textAlign: 'center'}}>
            <Card variant="outlined">
                <CardContent>
                    <Typography variant="h6" color="secondary" gutterBottom sx={{mb: 2}}>
                        {t("loginPrompt")}
                    </Typography>
                </CardContent>
                <CardActions sx={{marginBottom: '10px'}}>
                    <Grid item xs={12} sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <Stack direction="column" spacing={1}>
                            <Button
                                variant="contained"
                                color="primary"
                                className="mt-5"
                                onClick={() => window.location.href = websiteUrl}
                            >
                                {t("backToTenant", { tenantName: cfg?.name || 'Home' })}
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => navigate('/nieuwe-reservatie')}
                            >
                                {t("goToLogin")}
                            </Button>
                        </Stack>
                    </Grid>
                </CardActions>
            </Card>
        </Grid>)
}

export default Login;
